document.addEventListener('DOMContentLoaded', function () {
  // Only the identified sales widget is affected; never rewrite its sales claims.
  function watchSalesWidget() {
    var widget = document.getElementById('cb-widget-sales-pop');
    if (!widget || widget.dataset.bobalabObserved) return;
    widget.dataset.bobalabObserved = 'true';
    function checkEntry() {
      var title = widget.querySelector('.cbSalesPopInnerTitle');
      widget.dataset.incompleteEntry = String(!!title && /\b(undefined|null)\b/i.test(title.textContent));
    }
    new MutationObserver(checkEntry).observe(widget, { childList: true, subtree: true, characterData: true });
    checkEntry();
  }
  watchSalesWidget();
  new MutationObserver(watchSalesWidget).observe(document.body, { childList: true });
  document.querySelectorAll('[data-product-description]').forEach(function (description) {
    description.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(function (heading) {
      if (!heading.textContent.replace(/[\s\u200b\ufeff]/g, '') && !heading.querySelector('img,video,iframe')) heading.remove();
    });
    description.querySelectorAll('h4,h5,h6').forEach(function (heading) {
      var replacement = document.createElement('h3'); replacement.innerHTML = heading.innerHTML; heading.replaceWith(replacement);
    });
    description.querySelectorAll('tr').forEach(function (row) {
      var cells = row.querySelectorAll('td,th');
      if (cells.length === 2 && /^allergens:?$/i.test(cells[0].textContent.trim()) && !cells[1].textContent.trim() && !cells[1].querySelector('img')) {
        cells[1].textContent = 'Please check the product packaging or contact us for the current allergen information.';
      }
    });
  });
  document.querySelectorAll('[data-gallery-image]').forEach(function (button) {
    button.addEventListener('click', function () {
      var product = button.closest('.product'); var image = product.querySelector('[data-main-image]');
      image.removeAttribute('srcset'); image.src = button.dataset.galleryImage; image.alt = button.querySelector('img').alt;
      product.querySelectorAll('[data-gallery-image]').forEach(function (thumb) { thumb.setAttribute('aria-pressed', String(thumb === button)); });
    });
  });
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var variants = JSON.parse(form.querySelector('[data-product-variants]').textContent);
    function updateDetails() {
      var id = form.querySelector('[data-variant-id]'); var variant = variants.find(function (item) { return String(item.id) === id.value; });
      var product = form.closest('.product'); var status = product.querySelector('[data-product-availability]');
      if (status) status.textContent = id.disabled ? 'This combination is unavailable' : variant && variant.available ? 'Available to order' : 'Currently sold out';
      if (!id.disabled && variant) {
        var url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState(null, '', url);
        if (variant.image) { var image = product.querySelector('[data-main-image]'); if (image) { image.removeAttribute('srcset'); image.src = variant.image; image.alt = variant.image_alt || ''; product.querySelectorAll('[data-gallery-image]').forEach(function (thumb) { thumb.setAttribute('aria-pressed', String(thumb.dataset.galleryImage === variant.image)); }); } }
      }
    }
    form.querySelectorAll('[data-option-select]').forEach(function (select) { select.addEventListener('change', updateDetails); });
  });
  document.querySelectorAll('[data-load-video]').forEach(function (button) {
    button.addEventListener('click', function () {
      if (!/^\d+$/.test(button.dataset.videoId)) return;
      var frame = document.createElement('iframe'); frame.className = 'bl-frame'; frame.title = button.getAttribute('aria-label').replace('Load ', '');
      frame.src = 'https://www.tiktok.com/player/v1/' + button.dataset.videoId + '?autoplay=0'; frame.allow = 'fullscreen'; frame.allowFullscreen = true;
      button.closest('.media-placeholder').replaceWith(frame);
    });
  });
});
